export default "__VITE_ASSET__Ba89Cy7P__"